/**
 * 默认元素名称翻译
 * 用于在非React组件（如store）中获取本地化的默认名称
 */

// 默认语言：中文
let currentLanguage = 'zh-CN';

export function setDefaultNamesLanguage(lang: string) {
  currentLanguage = lang;
}

const defaultNames = {
  'zh-CN': {
    wall: '墙体',
    door: '门',
    window: '窗',
    area: '区域',
    furniture: '家具',
    circle: '圆形',
    polygon: '多边形',
    stair: '楼梯',
    shape: '图形',
    text: '文本',
    model3d: '3D模型',
    boundaryArea: '底图边界区域',
  },
  'en-US': {
    wall: 'Wall',
    door: 'Door',
    window: 'Window',
    area: 'Area',
    furniture: 'Furniture',
    circle: 'Circle',
    polygon: 'Polygon',
    stair: 'Stair',
    shape: 'Shape',
    text: 'Text',
    model3d: '3D Model',
    boundaryArea: 'Background Boundary Area',
  },
};

export function getDefaultName(type: string): string {
  const lang = currentLanguage as keyof typeof defaultNames;
  const nameType = type as keyof typeof defaultNames['zh-CN'];
  return defaultNames[lang]?.[nameType] || defaultNames['zh-CN'][nameType] || type;
}
